import { type CustomResponseFormat } from "api/instance";
import { DataState } from "../recoil/onboardingDataAtom";
import { axiosInstancePromotion } from "./instancePromotion";
import { OnboardingDemographicType } from "./onboardingApi";
import { type StoredChannelParams } from "../analytics/channelParams";
import { getAdChannel } from "../routes/adFunnel";

export const WEB_FUNNEL_DOMAIN = "web-funnel";

export const WEB_FUNNEL_BEGIN = "begin";
export const WEB_FUNNEL_IDENTIFY = "identify";
export const WEB_FUNNEL_PAGE_DATA_SAVE_ENDPOINT = "page-data/save";
export const WEB_FUNNEL_GENDER_SUBMIT_ENDPOINT = "gender/submit";
export const WEB_FUNNEL_EVENT_TRACK_ENDPOINT = "event/track";
export const WEB_FUNNEL_AGE_SUBMIT_ENDPOINT = "age/submit";
export const WEB_FUNNEL_JOB_SUBMIT_ENDPOINT = "job/submit";
export const WEB_FUNNEL_DEMOGRAPHIC_LOAD_ENDPOINT = "demographic/load";
export const WEB_FUNNEL_CHANNEL_SAVE_ENDPOINT = "channel/save";

export interface WebFunnelBeginResultType {
  onboardingType?: string;
}

export const webFunnelApi = {
  begin: (mixpanelDistinctId: string, onboardingType?: string) =>
    axiosInstancePromotion.post<CustomResponseFormat<WebFunnelBeginResultType>>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_BEGIN}`,
      {
        clientId: mixpanelDistinctId,
        ...(onboardingType && { onboardingType }),
        version: "v4",
      }
    ),

  identify: (mixpanelDistinctId: string) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_IDENTIFY}`,
      {
        clientId: mixpanelDistinctId,
      }
    ),

  savePageData: (mixpanelDistinctId: string, pageId: string, data: DataState) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_PAGE_DATA_SAVE_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        pageId: pageId,
        data: JSON.stringify(data),
      }
    ),

  submitAge: (mixpanelDistinctId: string, age: number) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_AGE_SUBMIT_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        age: age,
      }
    ),

  submitJob: (mixpanelDistinctId: string, job: string) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_JOB_SUBMIT_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        job: job,
      }
    ),

  submitGender: (mixpanelDistinctId: string, gender: string) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_GENDER_SUBMIT_ENDPOINT}`,
      {
        clientId: mixpanelDistinctId,
        gender: gender,
      }
    ),

  // 가입 시점 1회 호출 (Bearer 인증 — 유저 식별은 토큰). 백엔드가 distancing 프로필 "유입 채널"로 동기화
  saveChannelParams: (channel: StoredChannelParams) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_CHANNEL_SAVE_ENDPOINT}`,
      {
        ...channel.params,
        capturedAt: channel.capturedAt,
      }
    ),

  trackEvent: (eventName: string, properties?: { [key: string]: any }) =>
    axiosInstancePromotion.post<void>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_EVENT_TRACK_ENDPOINT}`,
      {
        eventName: eventName,
        properties: properties,
        // 웹퍼널 광고 채널(google/meta) — 서버가 Mixpanel(distancing) 이벤트에 channel 로 붙인다
        adChannel: getAdChannel(),
      }
    ),
  loadDemographic: () =>
    axiosInstancePromotion.get<CustomResponseFormat<OnboardingDemographicType>>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_DEMOGRAPHIC_LOAD_ENDPOINT}`
    ),
};
